import img1 from './Instrumental/img1.jpg'
import img2 from './Instrumental/img2.jpg'
import img3 from './Instrumental/img3.jpg'
import img4 from './Instrumental/img4.jpg'
import img5 from './Instrumental/img5.jpg'
import img6 from './Instrumental/img6.jpg'
import img7 from './Instrumental/img7.jpg'
import img8 from './Instrumental/img8.jpg'
import img9 from './Instrumental/img9.jpg'
import img10 from './Instrumental/img10.jpg'
import img11 from './Instrumental/img11.jpg'
import img12 from './Instrumental/img12.jpg'
import img13 from './Instrumental/img13.jpg'
import img14 from './Instrumental/img14.jpg'
import img15 from './Instrumental/img15.jpg'
import img16 from './Instrumental/img16.jpg'
import img17 from './Instrumental/img17.jpg'
import {Footer} from './Footer'
import {Component} from 'react'
import { Row, Col, Container, Card, Accordion } from 'react-bootstrap'
import {Navigation} from './Navigation'

export class Instrumental extends Component {
    render() {
        return (
            <div>
                <Navigation />
                <Container>
                    <br />
                    <h1 className="text-center">Instrumental</h1>
                    <p>
                        Si necesita comprar equipo médico asegúrese de que su equipo cumpla con la calidad que busca.<br />
                        Haga su pedido en línea. Y recuerde confirmar con nosotros su pedido de medicamentos.<br />
                        ¿No encontró algún equipo que necesita? ¡Comuníquese con nosotros! será un gusto apoyarle.<br />
                        Diferentes calidades de Acero Inoxidable: Alemana, USA, Paquistani y China
                    </p>
                    <br />

                    {/* Nueva sintaxis de Accordion para Bootstrap 5 */}
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Instrumental de acero inoxidable</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Bacín</li><li>Bandejas</li><li>Copas para medicamentos</li>
                                            <li>Cucharillas para Legrado</li><li>Dilatadores</li><li>Equipos para Cesárea</li>
                                            <li>Equipos para parto</li><li>Espéculos Vaginales</li><li>Esterilizadores</li>
                                            <li>Estuches de Cirugía Menor y Disección</li><li>kits de cirugía mayor y menor</li>
                                            <li>Laringoscopios</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Martillo de reflejos</li><li>Ollas Autoclaves</li><li>Otorrinolaringoscopios</li>
                                            <li>Palanganas</li><li>Pinzas</li><li>Porta Pinzas</li><li>Porta Termómetros</li>
                                            <li>Riñones</li><li>Set de Diagnostico</li><li>Tenáculos</li><li>Tijeras</li><li>Urinales</li>
                                        </ul>
                                    </Col>
                                </Row>

                                {/* Galería de imágenes dentro del primer acordeón reemplazando CardGroup */}
                                <Row xs={1} md={3} className="g-4 mt-3">
                                    {[
                                        { img: img2, title: "Especulos vaginales" },
                                        { img: img3, title: "Bandeja con tapadera" },
                                        { img: img4, title: "Porta pinzas" },
                                        { img: img5, title: "Kit de cirugía pequeña" },
                                        { img: img6, title: "Kits de acero inoxidable" },
                                        { img: img7, title: "Palanganas de acero inoxidable" },
                                        { img: img8, title: "Palangana de acero inoxidable" },
                                        { img: img13, title: "Riñones de acero inoxidable" },
                                        { img: img14, title: "Tijeras" },
                                        { img: img15, title: "Tijeras" },
                                        { img: img16, title: "Tijeras" },
                                        { img: img17, title: "Tijeras" }
                                    ].map((item, idx) => (
                                        <Col key={idx}>
                                            <Card className="h-100 text-center border-info">
                                                <Card.Img variant="top" src={item.img} />
                                                <Card.Body>
                                                    <Card.Title>{item.title}</Card.Title>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Pinzas de disección</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <ul>
                                    <li>Pinza Cushing</li><li>Pinza Potts – Smith</li><li>Pinza Rusa</li>
                                    <li>Pinza Semkem</li><li>Pinzas Adson</li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Pinzas hemostáticas</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Pinza Aro</li><li>Pinza Backhaus</li><li>Pinza Bertola</li>
                                            <li>Pinza Bozeman</li><li>Pinza Chapul</li><li>Pinza ClampsCrafford</li>
                                            <li>Pinza ClampsWerthein</li><li>Pinza Crile</li><li>Pinza Crile Rankin</li>
                                            <li>Pinza Dandy para cuero cabelludo</li><li>Pinza Desjardin para cístico</li>
                                            <li>Pinza Doyen</li><li>Pinza Faure para arteria uterina</li>
                                            <li>Pinza Foerster</li><li>Pinza Gregoire</li><li>Pinza Guyon</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Pinza Halstead</li><li>Pinza HarringthonLovel doble útil</li>
                                            <li>Pinza Heaney</li><li>Pinza Heiss</li><li>Pinza Kell-Rankin</li>
                                            <li>Pinza Kelly</li><li>Pinza Kocher</li><li>Pinza Lahey</li>
                                            <li>Pinza Maier uterina</li><li>Pinza Martel</li><li>Pinza Mister</li>
                                            <li>Pinza Pean</li><li>Pinza Pozzi</li><li>Pinza Rochester Pean</li>
                                            <li>Pinza Schade</li><li>Pinza Schnidt</li>
                                        </ul>
                                    </Col>
                                </Row>
                                {/* Galería secundaria */}
                                <Row xs={1} md={3} className="g-4 mt-3">
                                    {[img1, img9, img10, img11, img12].map((image, idx) => (
                                        <Col key={idx}>
                                            <Card className="h-100 text-center border-info">
                                                <Card.Img variant="top" src={image} />
                                                <Card.Body><Card.Title>Pinzas</Card.Title></Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>Separadores</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <Row>
                                    <Col md={6}>
                                        <ul>
                                            <li>Separador Balfour</li><li>Separador Blefaróstato</li><li>Separador Caeiro</li>
                                            <li>Separador Cushing para venas</li><li>Separador Deaver</li><li>Separador Ferabeuff</li>
                                            <li>Separador Finochietto</li><li>Separador Gelpi</li><li>Separador Gosset</li>
                                            <li>Separador Jansen</li><li>Separador Langenbeck</li>
                                        </ul>
                                    </Col>
                                    <Col md={6}>
                                        <ul>
                                            <li>Separador Love para nervios</li><li>Separador Millin</li><li>Separador Millin de alambre</li>
                                            <li>Separador Richardson</li><li>Separador Roux</li><li>Separador Senn-Mueller</li>
                                            <li>Separador Weithlaner</li><li>Separador Wolkmann</li><li>Separadores Adson</li><li>Valva Doyen</li>
                                        </ul>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>Instrumental para sutura</Accordion.Header>
                            <Accordion.Body className="fondo-texto">
                                <ul>
                                    <li>Pinza porta agujas Bozeman</li><li>Pinza porta agujas de bakey</li>
                                    <li>pinza porta agujas Halsey</li><li>Pinza porta agujas Masson</li>
                                    <li>Pinza Porta agujas Ryder</li><li>Pinza porta agujas Tijera Olsen – Hegar</li>
                                    <li>Porta agujas finochietto</li><li>porta agujas hegar</li>
                                    <li>Porta agujas Mathieu</li><li>Porta agujas Mayo – Hegar</li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        {/* ... Se repite el patrón para los demás items ... */}
                    </Accordion>
                </Container>
                <Footer />
            </div>
        )
    }
}